"use client";

import { useEffect, useState } from 'react';
import type { PlanCatalog, PlanOption } from './plans';
import { fetchPlanCatalog } from './plans';

interface PlanCatalogState {
  plans: PlanOption[];
  freePlan: PlanOption | null;
  loading: boolean;
  error: string | null;
}

export function usePlanCatalog(): PlanCatalogState {
  const [plans, setPlans] = useState<PlanOption[]>([]);
  const [freePlan, setFreePlan] = useState<PlanOption | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const catalog = await fetchPlanCatalog();
        if (!cancelled) {
          setPlans(catalog.plans);
          setFreePlan(catalog.freePlan);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load plans');
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return { plans, freePlan, loading, error };
}
